import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NavService } from '../../../_services/_nav.service';
import { TranslateService } from '@ngx-translate/core';
import { ValidityEmployees } from '../../../_models/vigencias';

@Component({
  moduleId: module.id,
  templateUrl: './validity-employees.component.html',
  selector: 'validity-employees-component'
})
export class ValidityEmployeesComponent implements OnInit {
  @Input() listValidityEmployees: ValidityEmployees[] = [];
  busqueda: string;
  columnas: any[] = [];

  constructor( private router: Router,
               private _nav: NavService,
               private translateService: TranslateService) {
     this.busqueda = _nav.getSearch( 'document-management' );

  }

  ngOnInit(): void {
     this.setEncabezadoTable();
  }

  async setEncabezadoTable(){
   this.columnas = [
      { field: 'codigoFuncionalidadControl', header: await this.translateService.get( 'VIGENCIADEDATOS.LBL_CODIGO' ).toPromise(), sort: false },
      { field: 'funcionalidadControl', header: await this.translateService.get( 'VIGENCIADEDATOS.LBL_CONTROL' ).toPromise(), sort: false },
      { field: 'vigencia', header: await this.translateService.get( 'VIGENCIADEDATOS.LBL_TIPOVIGENCIA' ).toPromise(), sort: false },
      { field: 'duracionVigencia', header: await this.translateService.get( 'VIGENCIADEDATOS.LBL_VIGENCIA' ).toPromise(), sort: false },
      { field: 'acciones', header: await this.translateService.get( 'VIGENCIADEDATOS.LBL_ACCIONES' ).toPromise(), sort: false },
   ];
}

   edit(row: ValidityEmployees){
      this.router.navigate([`/apl/vigencias/validity-employees-edit/${row.idVigenciaTercero}`]);
   }

   setSearch() {
      this._nav.setSearch( 'document-management', this.busqueda );
   }

}